import React from "react";
import "react-tabs/style/react-tabs.css";
import { Button } from "react-bootstrap";
import { Badge } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CardBody } from "reactstrap";
import EditIcon from '@material-ui/icons/Create';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';

class PartnerLeads extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: [""],
      adminPass: "", statusEdit: [], statusUpdate: false, remarks: "", status: ""
    };
    this.submitHandler = this.submitHandler.bind(this);

  }

  submitHandler = () => {
    this.props.history.path("/user/user-create")
  }


  nextPath(path) {
    this.props.history.push({ pathname: path });
  }

  componentDidMount() {
    const url = process.env.REACT_APP_NODE_ENV + "/api/partnerLeads/fetchAll";
    fetch(url,{
      method:'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => {
        return response.json();
      }
    ).then(data => {
      this.setState({ userData: data })
    })
  }

  editStatusHandler = value => {
    const doesToggle = this.state.editStatus;
    this.setState({ statusEdit: value, editStatus: !doesToggle });
    this.setState({ status: value.status });
    this.setState({ remarks: value.remarks })
  };

  save = () => {
    this.setState({ editStatus: false })
    let postOrderData = "";
    if (this.state.statusUpdate) {
      postOrderData = {
        id: this.state.statusEdit.id, status: this.state.status, remarks: this.state.remarks
      };
      console.log(postOrderData);
      fetch(process.env.REACT_APP_NODE_ENV + '/api/partnerLeads/updatePartnerLeads', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify(postOrderData)
      }).then((res) => res.json())
        .then((data) => this.componentDidMount())
        .catch((err) => console.log(err))
    }
    else {
      this.componentDidMount();
    }
  }

  popUpCancel = () => {
    this.setState({ editStatus: false, statusUpdate: false });
  }

  handleEditFormFields = (event) => {
    this.setState({ statusUpdate: true })
    switch (event.target.id) {
      case "statusUpdate":
        this.setState({ status: event.target.value });
        break;
      case "remarks":
        this.setState({ remarks: event.target.value });
        break;
      default: break;
    }
  }

  render() {

    let statusEdit = (
      <><div className="col-lg-4">
        <label> <b>Status</b> </label><select id="statusUpdate" className="form-control" value={this.state.status} onChange={this.handleEditFormFields} >
          <option value="New Lead">New Lead</option>
          <option value="In Process">In Process</option>
          <option value="Converted">Converted</option>
          <option value="Archive">Archive</option>
        </select></div>
        <div style={{ paddingTop: "20px" }} className="col-lg-8">
          <input type="text" className="form-control" id="remarks" placeholder="Remarks" value={this.state.remarks} onChange={this.handleEditFormFields} />
        </div></>)

    let dataArray = [];
    this.state.userData.map((data) => {
      let variant = "";
      if (data.status === "New Lead") { variant = "warning" }
      else if (data.status === "In Process") { variant = "primary" }
      else if (data.status === "Converted") { variant = "success" }
      else { variant = "danger" }
      let mdData = {
        key: data.id,
        id: data.id, FullName: data.name, PhoneNumber: data.phoneNumber, PartnerType: data.partnerType, Remarks: data.remarks,
        Status1: data.status + '&&' + variant, Status: data.status, actions: data
      };
      dataArray.push(mdData);
      return null;
    });


    const columns = [
      {
        name: "FullName",
        label: "Full Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "PhoneNumber",
        label: "Phone Number",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "PartnerType",
        label: "Partner Type",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "Remarks",
        label: "Remarks",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "Status1",
        label: "Status",
        options: {
          filter: false,
          sort: true,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            let datasFromValue = value.split("&&")
            return (<>  <Badge pill variant={datasFromValue[1]}>{datasFromValue[0]}</Badge>
            </>)
          }
        }
      },
      {
        name: "Status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
          display: false
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <><Tooltip title="Edit Status"><IconButton>
                <EditIcon onClick={() => this.editStatusHandler(value)} /></IconButton></Tooltip> </>
            );
          }
        }
      }
    ];


    const options = {
      filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false,
      downloadOptions: {
        filename: 'Partner Leads.csv',
      },
    };

    let PartnerLeadsTable = (<Card>
      <Card.Body>
        <MUIDataTable
          data={dataArray}
          columns={columns}
          options={options} />
      </Card.Body>
    </Card>);

    let editStatuss = null;
    if (this.state.editStatus) {
      editStatuss = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalHeader>Edit Details for - {this.state.statusEdit.name}</ModalHeader>
              <ModalBody>
                {statusEdit}
              </ModalBody>
              <ModalFooter>
                <Button variant="outline-primary" onClick={() => this.save()}>
                  Save
            </Button>&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={() => this.popUpCancel()}> Cancel </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }
 if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User") {
   
    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item active>Partner Lead Details</Breadcrumb.Item>
        </Breadcrumb>
        {editStatuss}
        {PartnerLeadsTable}
      </>
    );
 } else {
       return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item active>Partner Lead Details</Breadcrumb.Item>
        </Breadcrumb>
        {editStatuss}
        {PartnerLeadsTable}
      </>
    );
    }
 
  }
}

export default withRouter(PartnerLeads);
